import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@nk/shared/shared.module';
import { ButtonDirective } from '@nk/ui-lib';

@Component({
  selector: 'nk-page-forbidden-view',
  imports: [CommonModule, RouterModule, TranslateModule, SharedModule, ButtonDirective],
  templateUrl: './page-forbidden-view.component.html',
})
export class PageForbiddenViewComponent implements OnInit {
  public title: string;
  public message: string;

  constructor(private _activatedRoute: ActivatedRoute) {}

  public ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe((params) => {
      if (params) {
        this.title = params['title'];
        this.message = params['message'];
      }
    });
  }
}
